<template>
  <div class="container">
    <div class="title">
     <span class="span1">{{list[select].method}}</span>
     <span class="span2" @click="eventClick">选择其他支付方式</span>
    </div>
    <div class="info">
      <div class="info-title">
        <img v-lazy="list[select].icon" alt="">
      </div>
      <div class="ewm" >
        <div id="qrcode" ref="qrcode" class="qrcode">
           <div class="mask" v-if="isTimeOut">
             <div class="timeout-img">
               <img :src="require('@/assets/images/sx.png')" alt="">
             </div>
             <span>二维码已失效</span>
           </div>
        </div>
      </div>
      <div class="desc" v-if="!isTimeOut" >使用{{list[select].type}}扫一扫即可付款，手机付款更方便。</div>
      <div class="desc" v-else>二维码已失效 ，请 <span @click="reFreshQrcode"><img :src="require('@/assets/images/sxx.png')" alt="">重新刷新</span></div>

    </div>
    <popup ref="popup"></popup>
    <success v-if="successShow">支付成功</success>
  </div>
</template>
<script>
import popup from './cart-pay-popup'
 import QRCode from 'qrcodejs2'  //二维码
import Success from '../../../components/success.vue'
export default {
  components:{popup,Success},
  data(){
    return{
    //  type:0,
      list:[
        // {icon: require("@/assets/images/icon_success.png"),type:'货到付款',method:'货到付款'},
        {icon: require("@/assets/images/wxzf.png"),type:'微信',method:'微信支付'},
        {icon: require("@/assets/images/icon_alipay.png"),type:'支付宝',method:'支付宝支付'},
      ],
        msec:10*60*1000,
        isTimeOut:false,
        timer2:undefined,
        successShow:false
    }
  },
  props:['method','select','payList'],
  created(){

  },
  watch:{
    'method':function(t,f){
      this.qrcode.clear(); // 清除代码
      this.qrcode.makeCode(t);
    }
  },
  methods:{
    eventClick(){
      this.$emit('eventClick')
    },
    qrcode(){
      
       this.qrcode = new QRCode('qrcode',{
       width: 200, // 设置宽度，单位像素
       height: 200, // 设置高度，单位像素
       text: this.method,// 设置二维码内容或跳转地址
      })
     // this.getOrderstate() //生成二维码的时候调用监听支付是否成功的方法
    this.timer2 =  setInterval(() => {
       this.getOrderstate()
     }, 5000);
     },
     // 调用一个判断支付是否成功的接口，用这个接口我们监听微信是否支付成功
     getOrderstate(){
       this.$api.GET_ORDERCHECK({ orderId:this.payList.orderId}).then(res=>{
         if(res.status){
           this.successShow = true
           setTimeout(() => {
               this.$router.push({path:'/person/orderdetail',query:{type:2,sn:this.payList.sn}})
           }, 1000);
          
            clearInterval(this.timer2)
         }else{
         }
       })
     },
     success(){
        this.successShow = false
     },
     reFreshQrcode(){
        this.$emit('refresh')
        this.isTimeOut = false
        this.msec = 10*60*1000
         this.countdown()
     },
       //倒计时10分钟
    countdown() {
         this.msec -=1000
            // 将时间戳进行格式化00：00的形式
            let day = parseInt(this.msec / 1000 / 60 / 60 / 24);
            let hr = parseInt(this.msec / 1000 / 60 / 60 % 24);
            let min = parseInt(this.msec / 1000 / 60 % 60);
            let sec = parseInt(this.msec / 1000 % 60);
            this.day = day;
            this.hr = hr > 9 ? hr : '0' + hr;
            this.min = min > 9 ? min : '0' + min;
            this.sec = sec > 9 ? sec : '0' + sec;
            const that = this;
            // 倒计时结束时的操作
            if(hr ==0 && min ==0 && sec==0){
                this.isTimeOut = true
               clearTimeout( timer1)
            }else {
                var timer1 = setTimeout(() => {
                     that.countdown() 
                  }, 1000);
               }

        }

  },
  mounted(){
    this.qrcode()
     this.countdown()
  },
  destroyed(){
    clearInterval(this.timer2)

  }
}
</script>
<style lang="scss" scoped>
.container{
  border: 1px solid #f5f5f5;
}
  .title{
   display: flex;
   align-items: center;
    color: #505050;
    height: 64px;
    padding-left: 20px;
    line-height: 64px;
    border-bottom: 1px solid #f5f5f5;
    background: #fafafa;
    position: relative;
    .span1{
        font-size: 16px;
    }
    .span2{
      @include abs-y-c;
      right: 20px;
      cursor: pointer;
      background: #ffffff;
      border-radius: 16px;
      font-size: 12px;
      border: 1px solid #ededed;
      // display: inline-block;
      text-align: center;
      width: 132px;
      height: 30px;
      line-height: 30px;

    }
  }
  .info{
    padding-top: 56px;
    height: 478px;
    text-align: center;
    .ewm{
      margin-bottom: 2px;

      img{
        width: 220px;
        height: 220px;
      }
    }
    .desc{
      font-size: 14px;
      color: #83868a;
  
      span{
        color: #f43a3a;
        cursor: pointer;
      }
    }
  }
  .qrcode{
    position: relative;
      margin: 0 auto;
      display: inline-block;
      padding: 20px;
  }
  .mask{
    position: absolute;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    opacity: 80%;
    align-items: center;
      @include flex-d-c;
    .timeout-img{
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
      img{
        @include size(100%,100%)
      }
    }
    span{
      font-size: 16px;
      color: #ffffff;
      font-weight: bold;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/cart/components/cart-pay-method.vue